import { Link } from "gatsby"
import React from "react"
import * as styles from "./button.module.scss"

const ButtonInternal = ({ data, display }) => {
  const buttonUrl = "/" + data.internalPageReference?.slug

  const buttonColor = data.buttonColor[0]

  const buttonStyle = () => {
    switch (buttonColor) {
      case "Yellow":
        return `bg-[#006ef5] py-4 px-[1.375rem] rounded-full text-white cursor-pointer group ${
          display ? display : ""
        } hover:bg-[#00469d] min-w-[200px] text-center font-medium max-w-fit transition-all
`
      case "Transparent":
        return `bg-white border-2 border-edc-green text-edc-green py-2 px-2 xs:px-4 rounded-3xl cursor-pointer group ${display} hover:shadow-md hover:bg-opacity-90 hover:bg-edc-green hover:text-white max-w-fit transition-all md:min-w-[140px] font-medium`
      default:
        return `bg-white border-2 border-edc-green text-edc-green py-2 px-2 xs:px-4 rounded-3xl cursor-pointer group ${display} hover:shadow-md hover:bg-opacity-90 hover:bg-edc-green hover:text-white max-w-fit transition-all md:min-w-[140px] font-medium`
    }
  }

  return (
    <Link className={buttonStyle()} to={buttonUrl ? buttonUrl : data.buttonUrl}>
      {data.buttonText}
    </Link>
  )
}

export default ButtonInternal
